import React, { Component } from 'reactn'
import Api from '../Services/Api'
import { Button } from 'react-bootstrap'
import { toast, Modal } from '../Components/ui'
import { FiSend, FiUsers, FiTrash2 } from 'react-icons/fi'

const DEF_OBJ = {
  title: '',
  body: '',
  groupName: '',
  selectedGroupName: '...',
  groupId: null,
  usersGroup: [],
  groups: [],
  newGroup: false,
  sendToGroupId: null,
  all: null,
  codFornitore: '...'
}

class Notifications extends Component {
  constructor (props) {
    super(props)
    this.state = {
      users: [],
      notifications: [],
      ...DEF_OBJ
    }
  }

  async componentDidMount () {
    const res = await Api.get('/users')
    if (res.ok) {
      this.setState({ users: res.data })
      await this.fetchNotifications()
      await this.fetchGroups()
    } else {
      toast.error('Impossibile recuperare gli utenti')
    }
  }

  async fetchNotifications () {
    const res = await Api.get('/notifications')
    if (res.ok) {
      this.setState({ notifications: res.data.reverse() })
    } else {
      toast.error('Impossibile recuperare le notifiche')
    }
  }

  async fetchGroups () {
    const ret = await Api.get('/groups')
    this.setState({ groups: ret.data })
  }

  async sendPushNotification () {
    const { codFornitore, title, body, all, sendToGroupId } = this.state

    if (!title || !body || (!all && !sendToGroupId && codFornitore === '...')) {
      toast.error('Verifica i dati immessi prima di inviare la notifica push')
      return
    }

    const now = new Date()
    const pad = n => String(n).padStart(2, '0')
    const date = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`

    const res = await Api.post('/notifications', { codFornitore, title, body, date, all, sendToGroupId })
    if (res.ok) {
      toast.success('Notifica push inviata con successo')
      this.setState(DEF_OBJ)
      await this.fetchNotifications()
      await this.fetchGroups()
    } else {
      toast.error('Impossibile inviare la notifica push')
    }
  }

  async deleteNotification (_id) {
    const res = await Api.delete(`/notifications/${_id}`)
    if (res.ok) {
      toast.success('Notifica eliminata')
      await this.fetchNotifications()
    } else {
      toast.error('Impossibile eliminare la notifica')
    }
  }

  deleteUserGroup (codFornitore) {
    this.setState({ usersGroup: this.state.usersGroup.filter(s => s.codFornitore !== codFornitore) })
  }

  async saveNewGroup () {
    const { groupName, usersGroup } = this.state
    const res = await Api.post('/groups', { groupName, usersGroup })
    if (res.ok) {
      toast.success('Gruppo creato con successo')
      this.setState(DEF_OBJ)
      await this.fetchGroups()
    } else {
      toast.error('Impossibile creare il gruppo')
    }
  }

  async updateNewGroup () {
    const { groupId, usersGroup } = this.state
    const res = await Api.patch(`/groups/${groupId}`, { usersGroup })
    if (res.ok) {
      toast.success('Gruppo aggiornato con successo')
      this.setState(DEF_OBJ)
      await this.fetchGroups()
    } else {
      toast.error('Impossibile aggiornare il gruppo')
    }
  }

  async deleteNewGroup () {
    const { groupId } = this.state
    const res = await Api.delete(`/groups/${groupId}`)
    if (res.ok) {
      toast.success('Gruppo eliminato con successo')
      this.setState(DEF_OBJ)
      await this.fetchGroups()
    } else {
      toast.error('Impossibile eliminare il gruppo')
    }
  }

  render () {
    const {
      users, notifications, title, body, newGroup,
      groupName, usersGroup, groups, all, selectedGroupName,
      sendToGroupId, codFornitore, groupId
    } = this.state

    return (
      <div>
        <div className='ui-page-header'>
          <h3>Notifiche</h3>
          <Button variant='outline-primary' size='sm' onClick={() => this.setState({ newGroup: true })}>
            <FiUsers style={{ marginRight: 4 }} /> Gestisci gruppi
          </Button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '340px 1fr', gap: 24, alignItems: 'start' }}>
          {/* Left: Send form */}
          <div style={{ background: 'var(--sf-surface)', border: '1px solid var(--sf-border)', borderRadius: 'var(--sf-radius-sm)', padding: 20 }}>
            <h6 style={{ fontWeight: 700, marginBottom: 14 }}>Invia notifica</h6>
            <div className='ui-field' style={{ marginBottom: 12 }}>
              <label>Titolo</label>
              <input type='text' value={title} placeholder='Titolo del messaggio' onChange={e => this.setState({ title: e.target.value })} />
            </div>
            <div className='ui-field' style={{ marginBottom: 12 }}>
              <label>Messaggio ({body.length}/1200)</label>
              <textarea value={body} placeholder='Messaggio' rows={6} style={{ minHeight: 120 }} onChange={e => e.target.value.length <= 1200 && this.setState({ body: e.target.value })} />
            </div>

            <div className='ui-checkbox-row' style={{ marginBottom: 12 }}>
              <input type='checkbox' checked={!!all} onChange={e => this.setState({ all: e.target.checked })} disabled={!!sendToGroupId || (codFornitore && codFornitore !== '...')} />
              <span>Invia a tutti i soci</span>
            </div>

            <div className='ui-field' style={{ marginBottom: 12 }}>
              <label>oppure seleziona un gruppo</label>
              <select className='form-select' disabled={!groups.length || all || (codFornitore && codFornitore !== '...')} onChange={e => {
                if (e.target.value !== '...') {
                  this.setState({ sendToGroupId: e.target.value.split('|')[0] })
                } else {
                  this.setState({ sendToGroupId: null })
                }
              }}>
                <option>...</option>
                {groups.map((group, i) => <option key={i} value={`${group._id}|${group.groupName}`}>{group.groupName}</option>)}
              </select>
            </div>

            <div className='ui-field' style={{ marginBottom: 16 }}>
              <label>oppure seleziona un singolo socio</label>
              <select className='form-select' value={codFornitore} disabled={!users.length || all || !!sendToGroupId} onChange={e => this.setState({ codFornitore: e.target.value !== '...' ? e.target.value : null })}>
                <option value='...'>...</option>
                {users.map((user, i) => <option key={i} value={user.email}>{user.email} - {user.name}</option>)}
              </select>
            </div>

            <Button variant='primary' style={{ width: '100%' }} onClick={() => this.sendPushNotification()}>
              <FiSend style={{ marginRight: 6 }} /> Invia notifica
            </Button>
          </div>

          {/* Right: History */}
          <div>
            <h6 style={{ fontWeight: 700, marginBottom: 14 }}>Storico notifiche</h6>
            <div className='ui-table-wrap'>
              <table className='ui-table'>
                <thead>
                  <tr>
                    <th>Cod. Fornitore</th>
                    <th>Titolo</th>
                    <th>Messaggio</th>
                    <th>Data</th>
                    <th>Tutti</th>
                    <th>Gruppo</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((n, i) => (
                    <tr key={i}>
                      <td>{n.codFornitore}</td>
                      <td>{n.title}</td>
                      <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.body}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{n.date}</td>
                      <td>{n.all ? <span className='ui-badge ui-badge-open'>Sì</span> : '-'}</td>
                      <td>{n.sendToGroupId ? groups.find(g => g._id === n.sendToGroupId)?.groupName : '-'}</td>
                      <td><Button size='sm' variant='danger' onClick={() => this.deleteNotification(n._id)}><FiTrash2 /></Button></td>
                    </tr>
                  ))}
                  {notifications.length === 0 && (
                    <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: 'var(--sf-text-muted)' }}>Nessuna notifica</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Groups Modal */}
        <Modal
          isOpen={newGroup}
          onClose={() => this.setState({ newGroup: false })}
          title='Gestione Gruppi'
          width={560}
          footer={
            <>
              {selectedGroupName === '...'
                ? <Button variant='primary' onClick={() => this.saveNewGroup()}>Crea gruppo</Button>
                : <Button variant='primary' onClick={() => this.updateNewGroup()}>Aggiorna gruppo</Button>}
            </>
          }
        >
          <div className='ui-form-grid'>
            <div className='ui-field ui-col-12'>
              <label>Nome del nuovo gruppo</label>
              <input type='text' value={groupName} onChange={e => this.setState({ groupName: e.target.value })} />
            </div>

            <div className='ui-field ui-col-12'>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <label>oppure modifica un gruppo esistente</label>
                {groupId && <Button variant='danger' size='sm' onClick={() => this.deleteNewGroup()}>Elimina gruppo</Button>}
              </div>
              <select className='form-select' disabled={!groups.length} onChange={e => {
                if (e.target.value !== '...') {
                  const item = e.target.value.split('|')
                  const found = groups.find(g => g.groupName === item[1])
                  this.setState({ selectedGroupName: item[1], groupId: item[0], usersGroup: found?.usersGroup || [] })
                }
              }}>
                <option>...</option>
                {groups.map((group, i) => <option key={i} value={`${group._id}|${group.groupName}`}>{group.groupName}</option>)}
              </select>
            </div>

            <div className='ui-field ui-col-12'>
              <label>Aggiungi un socio</label>
              <select className='form-select' disabled={!users.length} onChange={e => {
                if (e.target.value !== '...') {
                  const item = e.target.value.split('|')
                  const update = [...usersGroup, { codFornitore: item[0], fornitore: item[1] }]
                  const unique = Array.from(new Set(update.map(JSON.stringify))).map(JSON.parse)
                  this.setState({ usersGroup: unique })
                }
              }}>
                <option>...</option>
                {users.map((user, i) => <option key={i} value={`${user.email}|${user.name}`}>{user.email} - {user.name}</option>)}
              </select>
            </div>
          </div>

          {usersGroup.length > 0 && (
            <div className='ui-table-wrap' style={{ marginTop: 16 }}>
              <table className='ui-table'>
                <thead>
                  <tr>
                    <th>Codice Fornitore</th>
                    <th>Ragione Sociale</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {usersGroup.map((s, i) => (
                    <tr key={i}>
                      <td>{s.codFornitore}</td>
                      <td>{s.fornitore}</td>
                      <td><Button size='sm' variant='danger' onClick={() => this.deleteUserGroup(s.codFornitore)}>Rimuovi</Button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal>
      </div>
    )
  }
}

export default Notifications
